import React from 'react';
import './index.css';

interface CustomPopupProps {
    isOpen: boolean;
    onClose?: () => void;
    children: React.ReactNode;
    hideMask?: boolean;  // 是否隐藏遮罩层
}

// 自定义一个专门处理淡入淡出，并且带遮罩的组件，可以用于各种弹窗
const CustomPopup: React.FC<CustomPopupProps> = ({isOpen, children, hideMask}) => {

    return (
        <div className="custom-popup-page">
            {/*遮罩*/}
            {hideMask === true ? undefined : <div
                // onClick={onClose}
                className={`custom-popup-overlay ${isOpen ? 'custom-popup-show' : 'custom-popup-hidden'}`}
            ></div>}
            {/*传入的组件*/}
            <div
                className={`custom-popup-children ${isOpen ? 'custom-popup-show' : 'custom-popup-hidden'}`}>
                {children}
            </div>
        </div>
    );
}
export default CustomPopup;